<template lang="html">
  <div class="main">
    <div class="back-button">
      <a-button type="link" @click="$router.push('/')">
        <a-icon type="arrow-left" />返回首页
      </a-button>
    </div>
    <div class="drugTop">
      <div class="drugLeft">
        <img :src="drugPic" alt=""/>
      </div>
      <div class="drugRight">
        <div class="drugName" style="font-size:28px;">{{ drugTitle }}</div>
        <div class="drugMes">
          <div class="drugMes_l">
            <div class="drugMes_t">{{ c1 }}</div>
            <div class="drugMes_t">{{ c2 }}</div>
          </div>
          <div class="drugMes_r">
            <div class="drugMes_t">{{ c3 }}</div>
          </div>
        </div>
        <!-- <div class="price">零售价格<span style="color:red;margin-left:20px;">¥</span> <span
            style="font-size:28px;color:red;">{{ p1 }}</span></div> -->
        <!-- <div class="" style="margin-top:20px;">
          <a-button style="background:#C40100;margin-right:30px;color:#FFF;" @click="login">立即购买</a-button>
          <a-button style="background:#C40100;color:#FFF;" @click="login">加入购物车</a-button>
        </div> -->
      </div>
    </div>
    <div class="drugBottom">
      <div class="drugBox">产品信息</div>
      <div class="drugInfo">
        <p>{{ c1 }}</p>
        <p>{{ c2 }}</p>
        <p>{{ c3 }}</p>
        <p>{{ c4 }}</p>
        <p>{{ c5 }}</p>
        <p>{{ c6 }}</p>
        <p>{{ c7 }}</p>
        <p>{{ c8 }}</p>
        <p>{{ c9 }}</p>
        <p>{{ c10 }}</p>
      </div>
    </div>
<!--    <div class="drugBottom">-->
<!--      <div class="drugBox">商家信息</div>-->
<!--      <div class="drugInfo">-->
<!--        <p>{{ q1 }}</p>-->
<!--        <p><span style="margin-right:20px;">服务：{{ q2 }}</span><span-->
<!--            style="margin-right:20px;">发货：{{ q3 }}</span><span style="margin-right:20px;">物流：{{ q4 }}</span><span>包装：{{-->
<!--            q5-->
<!--          }}</span>-->
<!--        </p>-->
<!--        <p>店铺评分：{{ q6 }}</p>-->
<!--        <p>发货时长：{{ q7 }}</p>-->
<!--        <p>营业时间：{{ q8 }}</p>-->
<!--        <p>店铺地址：{{ q9 }}</p>-->
<!--        <p>联系人：{{ q10 }}</p>-->
<!--        <p>联系电话：{{ q11 }}</p>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="drugBottom">-->
<!--      <div class="drugBox">最新评价</div>-->
<!--      <div class="drugInfo">-->
<!--        <p>匿名用户：非常好用</p>-->
<!--        <p>匿名用户：不错哦不错不错不错不错不错不错不错不错不错</p>-->
<!--        <p>匿名用户：非常捧非常好，质量问题没有话说。相信这个</p>-->
<!--        <p>匿名用户：补发的货已*到，此订单用作补货款</p>-->
<!--        <p>匿名用户：第一次购*，不错。</p>-->
<!--      </div>-->
<!--    </div>-->
    <Login v-show="isShow" @closeLogin="closeLogin" @fnRegister="fnRegister" style="position:fixed;z-index:110;"/>
    <Register v-show="Register" @goLogin="goLogin" style="position:fixed;z-index:110;"/>
  </div>
</template>

<script>
import Login from "@/common/login.vue";
import Register from "@/common/register.vue";

export default {
  components: {
    Login,
    Register,
  },
  name: "drugDetails",
  data() {
    return {
      isShow: false,
      isMask: false,
      Register: false,
      drugTitle: "",
      drugPic: "",
      p1: "",
      c1: "",
      c2: "",
      c3: "",
      c4: "",
      c5: "",
      c6: "",
      c7: "",
      c8: "",
      c9: "",
      c10: "",
      q1: "浙江和云网络科技有限公司",
      q2: "4.9",
      q3: "4.9",
      q4: "4.9",
      q5: "4.9",
      q6: "4.9",
      q7: "24小时内",
      q8: "09:00-18:00",
      q9: "浙江省杭州市西湖区转塘街道之江发展大厦204室",
      q10: "张经理",
      q11: "0571-87156686",
      drugList: [
        {
          id: 1,
          goodsPic: require("../assets/drug-1.jpg"),
          goodsName: "感冒灵颗粒",
          p1: "19.80",
          c1: "【产品名称】感冒灵颗粒",
          c2: "【商品名/商标】999牌",
          c3: "【规格】10g*9包/盒",
          c4:
              "【主要成分】岗梅、三叉苦、金盏银盘、野菊花、薄荷油、咖啡因、马来酸氯苯那敏、对乙酰氨基酚。辅料为滑石粉。",
          c5: "【性状】本品为胶囊剂，内容物为棕褐色的颗粒；味苦。",
          c6:
              "【适应症】解热镇痛。用于感冒引起的头痛，发热，鼻塞，流涕，咽痛。",
          c7: "【用法用量】开水冲服，一次10克（1袋），一日3次。",
          c8:
              "【不良反应】偶见皮疹、荨麻疹、药热及粒细胞减少；可见困倦、嗜睡、口渴、虚弱感；长期大量用药会导致肝肾功能异常。",
          c9: "【注意事项】",
          c10:
              "1.忌烟、酒及辛辣、生冷、油腻食物。2.不宜在服药期间同时服用滋补性中成药。3.本品含对乙酰氨基酚、马来酸氯苯那敏、咖啡因。服用本品期间不得饮酒或含有酒精的饮料；不能同时服用与本品E相似的其他抗感冒药；肝、肾功能不全者慎用；膀胱颈梗阻、甲状腺功能亢进、青光眼、高血压和前列腺肥大者慎用；孕妇及哺乳期妇女慎用；服药期间不得驾驶机、车、船、从事高空作业、机械作业及操作精密仪器。4.脾胃虚寒，症见腹痛、喜暖、泄泻者慎用。5.心脏病、糖尿病等慢性病严重者应在医师指导下服用。6.儿童、年老体弱者应在医师指导下服用。7.服药3天后症状无改善，或症状加重，或出现新的严重症状如胸闷、心悸等应立即停药，并去医院就诊。8.对本品过敏者禁用，过敏体质者慎用。9.本品F发生改变时禁止使用。10.儿童必须在成人监护下使用。11.请将本品放在儿童不能接触的地方。12.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 2,
          goodsPic: require("../assets/drug-2.png"),
          goodsName: "板蓝根颗粒",
          p1: "6.50",
          c1: "【产品名称】板蓝根颗粒",
          c2: "【商品名/商标】白云山",
          c3: "【规格】10g/袋",
          c4: "【主要成分】板蓝根。辅料为蔗糖，糊精。",
          c5: "【性状】本品为棕色或棕褐色的颗粒；味甜、微苦。",
          c6:
              "【适应症】清热解毒，凉血利咽。用于肺胃热盛所致的咽喉肿痛、口咽干燥；急性扁桃体炎见上述证候者。",
          c7: "【用法用量】口服。一次1-2袋，一日3-4次。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.忌烟酒、辛辣、鱼腥食物。2.不宜在服药期间同时服用滋补性中药。3.糖尿病患者及有高血压、心脏病、肝病、肾病等慢性病严重者应在医师指导下服用。4.儿童、孕妇、哺乳期妇女、年老体弱、脾虚便溏者应在医师指导下服用。5.扁桃体有化脓或发热体温超过38.5℃的患者应去医院就诊。6.服药3天症状无缓解，应去医院就诊。7.对本品过敏者禁用，过敏体质者慎用。8.本品F发生改变时禁止使用。9.儿童必须在成人监护下使用。10.请将本品放在儿童不能接触的地方。11.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 3,
          goodsPic: require("../assets/drug-3.png"),
          goodsName: "复方青橄榄利咽含片",
          p1: "14.5",
          c1: "【产品名称】复方青橄榄利咽含片",
          c2: "【商品名/商标】慢严舒柠",
          c3: "【规格】12片*2板",
          c4:
              "【主要成分】鲜青果、麦冬、玄参、地黄、薄荷脑，辅料为蔗糖、糊精、硬脂酸镁。",
          c5: "【性状】本品为浅棕色的异型片；气清香，味清凉、微甜。",
          c6:
              "【适应症】养阴润肺、清热解毒、清利咽喉、镇咳止痒，用于慢性咽炎、咽干、咽痒、刺激性咳嗽。",
          c7: "【用法用量】含服。一次1～2片，每小时一次，一日10～20片。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.忌辛辣、鱼腥食物。2.孕妇慎用。3.服药七天后症状无改善，或出现其他症状，应去医院就诊。4.按照G服用，儿童应在医师指导下服用。5.对本品过敏者禁用，过敏体质者慎用。6.药品F发生改变时禁止服用。7.儿童必须在成人的监护下使用。8.请将此药品放在儿童不能接触的地方。9.如正在服用其他药物，使用本品前请咨询医师或药师。",
        },
        {
          id: 4,
          goodsPic: require("../assets/drug-4.png"),
          goodsName: "感冒清热颗粒",
          p1: "13.00",
          c1: "【产品名称】感冒清热颗粒",
          c2: "【商品名/商标】同仁堂",
          c3: "【规格】12g*10袋/盒",
          c4:
              "【主要成分】荆芥穗、薄荷、防风、柴胡、紫苏叶、葛根、桔梗、苦杏仁、白芷、苦地丁、芦根。辅料为蔗糖、糊精。",
          c5: "【性状】本品为棕黄色的颗粒；味甜，微苦",
          c6:
              "【适应症】疏风散寒，解表清热。用于风寒感冒、头痛发热，恶寒身痛，鼻流清涕，咳嗽咽干。",
          c7: "【用法用量】开水冲服。一次1袋，一日2次。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.忌烟、酒及辛辣、生冷、油腻食物。2.不宜在服药期间同时服用滋补性中药。3.糖尿病患者及有高血压、心脏病、肝病、肾病等慢性病严重者应在医师指导下服用。 4.儿童、孕妇、哺乳期妇女、年老体弱者应在医师指导下服用。5.发热体温超过38.5℃的患者，应去医院就诊。6.服药3天症状无缓解，应去医院就诊。7.对本品过敏者禁用，过敏体质者慎用。8.本品F发生改变时禁止使用。9.儿童必须在成人监护下使用。10.请将本品放在儿童不能接触的地方。11.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 5,
          goodsPic: require("../assets/drug-5.png"),
          goodsName: "夏桑菊颗粒",
          p1: "17.99",
          c1: "【产品名称】夏桑菊颗粒",
          c2: "【商品名/商标】白云山",
          c3: "【规格】10g/袋",
          c4: "【主要成分】夏枯草、野菊花、桑叶。辅料:蔗糖粉。",
          c5: "【性状】本品为黄棕色至棕褐色的颗粒；味甜。",
          c6:
              "【适应症】清肝明目，疏风散热，清热解毒。用于风热感冒，门赤头痛，头晕耳鸣，咽喉肿痛，疔疮肿毒等症，并可用作清凉饮料。",
          c7: "【用法用量】口服，一次1-2袋（10～20克），一日3次。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.忌烟、酒及辛辣、生冷、油腻食物。2.不宜在服药期间同时服用滋补性中药。3.风寒感冒者不适用，其表现为恶寒重，发热轻，无汗，头痛，鼻塞，流清涕，喉痒咳嗽。4.高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。5.服药3天症状无缓解，或症状加重，或出现新的严重症状如胸闷、心悸等应立即停药，并去医院就诊。6.小儿、年老体弱者、孕妇应在医师指导下服用。7.脾胃虚寒，症见腹痛、泄泻者慎用。8.对本品过敏者禁用，过敏体质者慎用。9.本品F发生改变时禁止使用。10.儿童必须在成人监护下使用。11.请将本品放在儿童不能接触的地方。12.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 6,
          goodsPic: require("../assets/drug-6.png"),
          goodsName: "健胃消食片",
          p1: "9.80",
          c1: "【产品名称】健胃消食片",
          c2: "【商品名/商标】江中",
          c3: "【规格】0.8g*8片*4板/盒",
          c4:
              "【主要成分】太子参、陈皮、山药、麦芽（炒）、山楂。辅料为蔗糖、糊精、硬脂酸镁。",
          c5:
              "【性状】本品为淡棕黄色的薄膜衣异形片，除去包衣后显浅棕黄色；气略香，味微甜、酸。",
          c6:
              "【适应症】健胃消食。用于脾胃虚弱所致的食积，症见不思饮食、嗳腐酸臭、脘腹胀满；消化不良见上述证候者。",
          c7: "【用法用量】口服，可以咀嚼。成人一次3片，一日3次，小儿酌减。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.饮食宜清淡，忌酒及辛辣、生冷、油腻食物。2.有高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。3.儿童、孕妇、哺乳期妇女、年老体弱者应在医师指导下服用。4.服药3天症状无缓解，应去医院就诊。5.对本品过敏者禁用，过敏体质者慎用。6.本品F发生改变时禁止使用。7.儿童必须在成人监护下使用。8.请将本品放在儿童不能接触的地方。9.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 7,
          goodsPic: require("../assets/drug-7.png"),
          goodsName: "肠炎宁片",
          p1: "23.00",
          c1: "【产品名称】肠炎宁片",
          c2: "【商品名/商标】康恩贝",
          c3: "【规格】0.42g*24片/盒",
          c4:
              "【主要成分】地锦草、金毛耳草、樟树根、香薷、枫香树叶。辅料为蔗糖、羧甲淀粉钠、二氧化硅、硬脂酸、乙醇、胃溶型薄膜包衣预混料。",
          c5:
              "【性状】本品为薄膜衣片，除去包衣后显棕褐色；气芳香，味酸、微苦。",
          c6:
              "【适应症】清热利湿，行气。用于大肠湿热所致的泄泻，症见大便泄泻、腹痛腹胀；急慢性胃肠炎、腹泻、小儿消化不良见上述证候者。",
          c7: "【用法用量】口服。一次3-4片，一日3-4次；小儿酌减。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.饮食宜清淡，忌烟、酒及辛辣、生冷、油腻食物。2.不宜在服药期间同时服用滋补性中药。3.有慢性结肠炎、溃疡性结肠炎便脓血等慢性病史者，患泄泻时应去医院就诊。4.有高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。5.服药3天症状未缓解，应去医院就诊。6.儿童、年老体弱者应在医师指导下服用。7.对本品过敏者禁用，过敏体质者慎用。8.本品F发生改变时禁止使用。9.儿童必须在成人监护下使用。10.请将本品放在儿童不能接触的地方。11.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 8,
          goodsPic: require("../assets/drug-8.png"),
          goodsName: "奥美拉唑肠溶胶囊",
          p1: "27.99",
          c1: "【产品名称】奥美拉唑肠溶胶囊",
          c2: "【商品名/商标】金奥康",
          c3: "【规格】10毫克",
          c4:
              "【主要成分】本品每粒含奥美拉唑10毫克，辅料为:羟丙甲纤维素、聚乙二醇6000、二氧化钛、甲基丙烯酸-丙烯酸乙酯共聚物水分散体（L30D-55）、滑石粉、95%乙醇等",
          c5: "【性状】本品内容物为白色或类白色肠溶微丸",
          c6: "【适应症】",
          c7:
              "【用法用量】口服。成人，一次1片，一日1次（每24小时），必要时可加服1片，用温开水送服。本品必须整片吞服，不可咀嚼或压碎，更不可将本品压碎于食物中服用。",
          c8:
              "【不良反应】本品常见J为:头痛、腹泻、恶心、呕吐、便秘、腹痛及腹胀。偶见头晕、嗜睡、乏力、睡眠紊乱、感觉异常、皮疹、瘙痒、荨麻疹、肝功能试验异常等。罕有多汗、周围血管性水肿、低钠血症；血管水肿、发热及过敏性休克；白细胞减少症、血小板减少症、粒细胞缺乏症、全血细胞减少症；可逆性精神错乱、易激惹、抑郁、攻击和幻觉；男子女性型乳房；口干、味觉异常、口炎、念珠菌病；脱发、光过敏、多形性红斑；肝性脑病(先前有严重肝病者)，黄疸性或非黄疸性肝炎、肝衰竭；支气管痉挛；关节痛、肌痛、肌肉疲劳；间质性肾炎；视力模糊。",
          c9: "【注意事项】",
          c10:
              "1.使用不得超过7天，如症状未缓解或消失请咨询医师或药师。2.两个月以内不得再次服用，如症状反复，应立即就医。3.本品在以下情况下请勿使用:吞咽困难或疼痛；呕血；便血或黑便。这些可能是严重情况的征兆，请咨询医师。4.肝功能不全或血象不正常的患者请在医师指导下使用。5.假如出现烧心持续或加重症状，请停用本品并去医院就诊。6.儿童使用本品应在医师指导下进行。7.孕期、哺乳期妇女慎用。8.如服用过量或出现严重J，请立即就医。9.对本品过敏者禁用，过敏体质者慎用。10.本品F发生改变时禁止使用。11.请将本品放在儿童不能接触的地方。12.儿童必须在成人监护下使用。13.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 9,
          goodsPic: require("../assets/drug-9.png"),
          goodsName: "养胃舒胶囊",
          p1: "13.80",
          c1: "【产品名称】养胃舒胶囊",
          c2: "【商品名/商标】999 养胃舒胶囊 24粒",
          c3: "【规格】0.4g*12s",
          c4:
              "【主要成分】党参、陈皮、黄精(蒸)、山药、玄参、乌梅、山楂、北沙参、干姜、菟丝子、白术(炒)。辅料为二氧化硅、玉米淀粉、滑石粉。",
          c5:
              "【性状】本品为色胶囊剂，内容物为棕黄色至棕褐色的细粉和颗粒；味微酸、苦。",
          c6: "【适应症】",
          c7: "【用法用量】口服，一次3粒，一日2次。",
          c8: "【不良反应】尚不明确。",
          c9: "【注意事项】",
          c10:
              "1.孕妇慎用。 2.湿热胃痛证及重度胃痛应在医师指导下服用。3.儿童及年老体虚患者应在医师指导下服用。4.服本药三天症状未改善，应停止服用，并去医院就诊。5.对本品过敏者禁用，过敏体质者慎用。6.本品F发生改变时禁止使用。7.儿童必须在成人监护下使用。8.请将本品放在儿童不能接触的地方。9.如正在使用其他药品，使用本品前请咨询医师或药师",
        },
        {
          id: 10,
          goodsPic: require("../assets/drug-10.png"),
          goodsName: "铝碳酸镁片",
          p1: "14.69",
          c1: "【产品名称】铝碳酸镁片",
          c2: "【商品名/商标】达喜",
          c3: "【规格】0.5g*20片/盒",
          c4:
              "【主要成分】本品每片含0.5克铝碳酸镁。辅料为:玉米淀粉、甘露醇、糖精钠、硬脂酸镁、薄荷香精、香蕉香精。",
          c5: "【性状】本品为白色片。",
          c6:
              "【适应症】1.慢性胃炎。2.与胃酸有关的胃部不适应症，如:胃痛、胃灼热感、饱胀等。",
          c7:
              "【用法用量】口服（咀嚼后服用）。一次1-2片，一日3次。餐后1-2小时、睡前或胃部不适时服用。",
          c8:
              "【不良反应】1.偶见便秘、稀便、口干和食欲缺乏。2.大剂量服用可导致软糊状便、大便次数增多、腹泻和呕吐。",
          c9: "【注意事项】",
          c10: "肾功能不全者、高镁血症、高钙血症者及严重心功能不全者慎用。",
        },
        {
          id: 11,
          goodsPic: require("../assets/drug-11.png"),
          goodsName: "维生素AD滴剂",
          p1: "29.80",
          c1: "【产品名称】维生素AD滴剂",
          c2: "【商品名/商标】",
          c3: "【规格】30粒",
          c4:
              "【主要成分】（0-1岁）本品每粒含维生素A1500单位，维生素D500单位，辅料为植物油维生素E",
          c5: "【性状】本品为黄 色至橙红色的澄明液体。",
          c6: "【适应症】",
          c7:
              "【用法用量】口服，将软囊滴嘴开口后，内容物滴入婴儿口中（开口方法:建议采用将滴嘴在开水中浸泡30秒，使胶皮融化）。也可直接嚼服胶丸。1次1粒，1日1次，注意I。",
          c8:
              "【不良反应】长期过量服用，可产生慢性中毒。早期表现为骨关节疼痛、肿胀、皮肤瘙痒、口唇干裂、发热、头痛、呕吐、便秘、腹泻、恶心等。",
          c9: "【注意事项】",
          c10:
              "1.必须按推荐剂量服用，不可超量服用。2.高钙血症孕妇可伴有维生素D敏感，功能上又能抑制甲状旁腺活动，以致婴儿有特殊面容、智力低下及患遗传性主动脉弓缩窄。3.儿童用量请咨询医师或药师。4.婴儿对维生素D敏感性个体差异大，有些婴儿对小剂量维生素D很敏感。5.老年人长期服用本品，可能因视黄醛清除延迟而至维生素A过量。6.如服用过量或出现严重J，应立即就医。7.对本品过敏者禁用，过敏体质者慎用。8.本品F发生改变时禁止使用。9.儿童必须在成 人监护下使用。10.请将本品放在儿童不能接触的地方。11.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 12,
          goodsPic: require("../assets/drug-12.png"),
          goodsName: "丁桂儿脐贴",
          p1: "16.80",
          c1: "【产品名称】丁桂儿脐贴",
          c2: "【商品名/商标】丁桂",
          c3: "【规格】每贴重1.6克。",
          c4:
              "【主要成分】丁香、肉桂、荜茇。辅料为凡士林、月桂氮卓酮、甘油、石蜡、羊毛脂。",
          c5: "【性状】本品为棕褐色的圆形软膏；气芳香。",
          c6: "【适应症】健脾温中，散寒止泻。适用于小儿泄泻，腹痛的辅助治疗。",
          c7: "【用法用量】外用。贴于脐部，一次1贴，24小时换药一次。",
          c8: "【不良反应】皮肤粘贴处偶见过敏反应。",
          c9: "【注意事项】",
          c10:
              "1.本品为外用药，禁止内服:皮肤破溃处禁用；2.忌食生冷油腻及不宜消化食物；3.婴儿应在医师指导下使用；4.感染性腹泻如肠炎、痢疾等疾病应去医院就诊；5.在应用贴膜后如发现脐部瘙痒、红肿有皮疹者即应停用；6.用药2~3天症状无缓解，应去医院就诊；7.对本品过敏者禁用，过敏体质者慎用；8.药品F发生改变时禁止使用；9.儿童必须在成 人监护下使用；10.请将本品放在儿童不能接触的地方；11.如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 13,
          goodsPic: require("../assets/drug-13.png"),
          goodsName: "葡萄糖酸锌口服溶液",
          p1: "8.00",
          c1: "【产品名称】葡萄糖酸锌口服溶液",
          c2: "【商品名/商标】三精 葡萄糖酸锌口服溶液 10ml*12支",
          c3: "【规格】10ml*12支",
          c4: "【主要成分】葡萄糖酸锌，加有适量矫味剂等。",
          c5:
              "【性状】本品为无色或淡黄色的澄清液，带矫味剂的芳香气，味甜，微涩。",
          c6: "【适应症】",
          c7:
              "【用法用量】口服。成人一次10～30ml，一日2～3次或遵医嘱。儿童按每日每公斤体重3.5～14mg给药，分2～3次服用或遵医嘱。",
          c8:
              "【不良反应】主要为胃部不适、恶心、呕吐等消化道刺激症状，一般减少药量或停药后反应可减少或消失。",
          c9: "【注意事项】",
          c10:
              "1.不宜空腹服用。2.过量服用，可影响铜、铁离子的代谢，故应在确证缺锌时使用，如需长期服用，必须在医生指导下使用。3.忌与四环素、多价磷酸盐、青霉胺等药物同时服用。",
        },
        {
          id: 14,
          goodsPic: require("../assets/drug-14.png"),
          goodsName: "三公仔",
          p1: "13.70",
          c1: "【产品名称】三公仔",
          c2: "【商品名/商标】三公仔",
          c3: "【规格】每袋装7g。",
          c4:
              "【主要成分】薏苡仁、稻芽、山楂、淡竹叶、钩藤、蝉蜕、甘草。辅料为蔗糖粉。",
          c5: "【性状】本品为淡黄棕色至红棕色的颗粒；气微，味甜、微苦。",
          c6:
              "【适应症】开胃消滞，清热定惊。用于小儿积滞化热，消化不良，不思饮食，烦躁易惊，夜寐不安，大便不畅，小便短赤。",
          c7: "【用法用量】开水冲服。一次3.5-7克，一日3次。",
          c8: "【不良反应】尚不明确。",
          c9: "【注意事项】",
          c10:
              "1．忌食生冷、油腻等不易消化食品。2．治疗一周后症状未见改善者，应及时到医院咨询医师。3．对本品过敏者禁用，过敏体质者慎用。4．本品F发生改变时禁止使用。5．儿童必须在成人监护下使用。6．请将本品放在儿童不能接触的地方。7．如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 15,
          goodsPic: require("../assets/drug-15.png"),
          goodsName: "布洛芬混悬液",
          p1: "19.00",
          c1: "【产品名称】布洛芬混悬液",
          c2: "【商品名/商标】美林",
          c3: "【规格】100ml/瓶",
          c4:
              "【主要成分】本品每毫升含主要E布洛芬20毫克，辅料为:预胶化淀粉、黄原胶、甘油、蔗糖、无水柠檬酸、苯甲酸钠、吐温80、食用色素、食用香精、纯水。",
          c5: "【性状】本品为橙色混悬液，味甜，有调味剂的芳香。",
          c6:
              "【适应症】用于儿童普通感冒或流行性感冒引起的发热。也用于缓解儿童轻至中度疼痛，如头痛、关节痛、偏头痛、牙痛、肌肉痛、神经痛。",
          c7:
              "【用法用量】口服，12岁以下小儿用量如下:1-3岁，体重10-15公斤，一次用量4ml；4-6岁，体重16-21公斤，一次用量5ml；7-9岁，22-27公斤，一次用量8ml；10-12岁，体重28-32公斤，一次用量10ml。",
          c8:
              "【不良反应】1.少数病人可出现恶心、呕吐、胃烧灼感或轻度消化不良、胃肠道溃疡及出血、转氨酶升高、头痛、头晕、耳鸣、视力模糊、精神紧张、嗜睡、下肢水肿或体重骤增。2.罕见皮疹、过敏性肾炎、膀肤炎、肾病综合征、肾乳头坏死或肾功能衰竭、支气管痉挛。",
          c9: "【注意事项】",
          c10:
              "1.本品为对症治疗药，不宜长期或大量使用，用于止痛不得超过5天，用于解热不得超过3天，症状不缓解，请咨询医师或药师。2.有下列情况患者慎用:支气管哮喘、肝肾功能不全、凝血机制或血小板功能障碍(如血友病)。3.下列情况患者应在医师指导下使用:有消化性溃疡史、胃肠道出血、心功能不全、高血压。4.1岁以下儿童应在医师指导下使用。5.不能同时服用其他含有解热镇痛药的药品(如某些复方抗感冒药)。6.如服用过量或出现严重J，应立即就医。7.对本品过敏者禁用，过敏体质者慎用。8.本品F发生改变时禁止使用。9.请将本品放在儿童不能接触的地方。10.儿童必须在成人监护下使用。11.如正在使用其他药品，使用本品前请咨询医师或药师。12.本品配有儿童安全盖，其打开方式见说明书所附图示。13.如出现胃肠道出血或溃疡、胸痛、气短、无力、言语含糊等情况，应停药并咨询医师。14.第一次使用本品如出现皮疹或过敏症状，应停药并咨询医师。",
        },
        {
          id: 16,
          goodsPic: require("../assets/drug-16.png"),
          goodsName: "洁尔阴洗液",
          p1: "16.60",
          c1: "【产品名称】洁尔阴洗液",
          c2: "【商品名/商标】恩威",
          c3: "【规格】300毫升/瓶",
          c4:
              "【主要成分】蛇床子、艾叶、独活、石菖蒲、苍术、薄荷、黄柏、黄芪、苦参、地肤子、茵陈、土荆皮、栀子、山银花。辅料:增溶剂、苯甲酸钠、香精。",
          c5: "【性状】棕色至深棕色液体,气芳香.",
          c6:
              "【适应症】清热燥湿、杀虫止痒。 ,1.主治妇女湿热带下，症见阴部瘙痒红肿，带下量多、色黄或如豆渣状，口苦口干，尿黄便结，舌红苔黄腻，脉弦数。适用于霉菌性、滴虫性及非特异性阴道炎；,2.用于下述皮肤病，症见皮肤瘙痒红肿。适用于急性湿疹（湿热型），接触性皮炎（热毒夹湿型），体股癣（风湿热型）。",
          c7:
              "【用法用量】外阴、阴道炎:用10%浓度洗液（即取本品10毫升加温开水至100毫升混匀）擦洗外阴，用冲洗器将10%的洁尔阴洗液送至阴道深部冲洗阴道，一日1次，七天为一疗程。",
          c8: "【不良反应】个别患者皮损处出现皮肤潮红加重、刺痛等。",
          c9: "【注意事项】",
          c10:
              "1、本品为外用药，禁止内服；2、忌食辛辣、生冷、油腻食物；3、切勿接触眼睛、口腔等黏膜处。皮肤破溃处禁用；4、治疗期间忌房事，配偶如有感染应同时治疗；5、未婚或绝经后患者，应在医师指导下使用；6、外阴白色病变、糖尿病所致的瘙痒不宜使用；7、带下伴血性分泌物，或伴有尿频、尿急、尿痛者，应去医院就诊；8、若使用中出现刺痛，皮肤潮红加重，暂停使用；9、带下量多用药7天、湿疹及体股癣用药2周症状无缓解，应去医院就诊；10、严格按说明书要求使用，不可随意提高浓度；外阴、肛门等处勿直接用原液涂擦；11、对本品过敏者禁用，过敏体质者慎用；12、药品F发生改变时禁止使用；13、请将此药品放在儿童不能接触的地方；14、如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 17,
          goodsPic: require("../assets/drug-17.png"),
          goodsName: "硝呋太尔制霉素阴道软胶囊",
          p1: "14.80",
          c1: "【产品名称】硝呋太尔制霉素阴道软胶囊",
          c2: "【商品名/商标】朗依",
          c3: "【规格】500mg*6粒/盒",
          c4: "【主要成分】品为复方制剂，其组份为硝呋太尔和制霉素。",
          c5: "【性状】本品为卵形阴道用软胶囊剂，内容物为黄色粘稠油状物。",
          c6: "【适应症】",
          c7:
              "【用法用量】本品阴道给药，每日一次，于晚上临睡前清洗外阴后，将本品1粒放入阴道后穹窿处，连用6天。建议使用1～2个疗程或遵医嘱。",
          c8:
              "【不良反应】品J较少。临床使用本品后可出现轻度外阴灼热、阴道干涩和恶心。",
          c9: "【注意事项】",
          c10:
              "1、本品仅供阴道给药，切忌口服。2、为获得较好疗效，尽量将本品置入阴道深处。3、连续使用本品1-2疗程后，如症状未缓解或消失，应咨询医师。4、孕妇应在医师指导下使用，哺乳期妇女慎用。5、无性生活史的女性应在医师指导下使用。6、使用本品期间勿饮用含酒精的饮料，酒精会引起不适或恶心，但这种反应会自行消失。7、给药时应洗净双手或戴指套或手套。8、用药期间注意个人卫生，防止重复感染，避免房事。9、用药部位如有烧灼感、红肿等情况应停药，并将局部药物洗净，必要时向医师咨询。10、使用本品时应避开月经期。11、对本品过敏者禁用，过敏体质者慎用。12、本品F发生改变时禁止使用。13、请将本品放在儿童不能接触的地方。14、如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 18,
          goodsPic: require("../assets/drug-18.png"),
          goodsName: "乌鸡白凤丸(水蜜丸)",
          p1: "15.00",
          c1: "【产品名称】乌鸡白凤丸(水蜜丸)",
          c2: "【商品名/商标】同仁堂",
          c3: "【规格】6g*6瓶/盒。",
          c4:
              "【主要成分】乌鸡(去毛、爪、肠)、人参、白芍、丹参、香附(醋制)、当归、牡蛎(煅)、鹿角、熟地黄、黄芪、桑螵蛸、鹿角霜、牡蛎(煅)等味。",
          c5: "【性状】本品为黑本品为黑褐色至黑色的水蜜丸；味甜、微苦。",
          c6:
              "【适应症】补气养血，调经止带。用于气血两亏引起:月经不调，行经腹痛，少腹冷痛，体弱乏力，腰酸腿软。",
          c7: "【用法用量】口服，温黄酒或温开水送服。一次6 克，一日2 次。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1.忌食寒凉、生冷食物。2.服药期间不宜喝茶和吃萝卜，不宜同时服用藜芦、五灵脂、皂荚或其制剂。3.感冒时不宜服用本药。4.月经过多者不宜服用本药，带下量多气臭者应去医院就诊。5.平素月经正常，突然出现月经量少，或月经错后，或阴道不规则出血应去医院就诊。6.按照G服用，长期服用应向医师咨询。7.服药二周症状无改善，应去医院就诊。8.对本药过敏者禁用，过敏体质者慎用。9.药品F发生改变时禁止服用。10.请将此药品放在儿童不能接触的地方。11.如正在服用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 19,
          goodsPic: require("../assets/drug-19.png"),
          goodsName: "妇科千金片",
          p1: "25.00",
          c1: "【产品名称】妇科千金片",
          c2: "【商品名/商标】千金",
          c3: "【规格】18粒*6板/盒。",
          c4:
              "【主要成分】千斤拔、金樱根、穿心莲、功劳木、单面针、当归、鸡血藤、党参。",
          c5: "【性状】本品为薄膜衣片、除去包衣后显灰褐色；味苦。",
          c6:
              "【适应症】清热除湿，益气化瘀。用于湿热瘀阻所致的带下病，腹痛，症见带下量多、色黄质稠，小腹疼痛，腰骶酸痛，神疲乏力；慢性盆腔炎见有上述证候者。",
          c7: "【用法用量】口服。一次6片，一日3次。",
          c8: "【不良反应】尚不明确",
          c9: "【注意事项】",
          c10:
              "1、忌辛辣、生冷、油腻食物；2、有高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用；3、少女、孕妇、绝经后患者均应在医师指导下服用；4、伴有赤带者，应去医院就诊；5、腹痛较重者，应及时去医院就诊；6、服药2周症状无缓解，应去医院就诊；7、对本品过敏者禁用，过敏体质者慎用；8、本品F发生改变时禁止使用；9、请将本品放在儿童不能接触的地方；10、如正在使用其他药品，使用本品前请咨询医师或药师。",
        },
        {
          id: 20,
          goodsPic: require("../assets/drug-20.png"),
          goodsName: "妇炎康片",
          p1: "7.50",
          c1: "【产品名称】妇炎康片",
          c2: "【商品名/商标】云丰",
          c3: "【规格】0.52g*54s/盒",
          c4:
              "【主要成分】赤芍、土茯苓、醋三棱、炒川楝子、醋莪术、醋廷胡索、炒芡实、当归、苦参、醋香附、黄柏 、丹参、山药。",
          c5:
              "【性状】本品为薄膜衣片，除去包衣后显黄棕色至黑褐色；气微，味微苦。",
          c6: "【适应症】",
          c7: "【用法用量】口服，一次3片，一日3次。",
          c8: "【不良反应】尚不明确。",
          c9: "【注意事项】",
          c10: "尚不明确。",
        },
        {
          id: 21,
          goodsPic: require("../assets/drug-21.png"),
          goodsName: "欧姆龙 电子血压计HEM-7121",
          p1: "218.00",
          c1: "【产品名称】欧姆龙 电子血压计HEM-7121",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】上臂式",
          c4: "【商品毛重】250.00g",
          c5: "【适用部位】腰部",
          c6: "【适用人群】通用",
          c7: "【国产/进口】国产",
          c8: "【注册证号】辽械注准20162200146",
          c9: "【生产企业】欧姆龙（大连）有限公司",
        },
        {
          id: 22,
          goodsPic: require("../assets/drug55.png"),
          goodsName: "欧姆龙 血糖仪 家用 HGM-112",
          p1: "218.00",
          c1: "【产品名称】欧姆龙 血糖仪 家用 HGM-112",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】血脂检测",
          c4: "【商品毛重】262.00g",
          c5: "【调码方式】全自动免调码",
          c6: "【国产/进口】国产",
          c7: "【注册证号】辽食药监械(准)字2014第2200224号",
          c8: "【生产企业】欧姆龙（大连）有限公司",
        },
        {
          id: 23,
          goodsPic: require("../assets/drug-23.png"),
          goodsName: "鱼跃（YUWELL）血氧仪YX303",
          p1: "229.00",
          c1: "【产品名称】鱼跃（YUWELL）血氧仪YX303",
          c2: "【商品名/商标】鱼跃（YUWELL）",
          c3: "【类别】指夹式",
          c4: "【商品毛重】105.00g",
          c5: "【智能警报】不带报警",
          c6: "【充电方式】电池",
          c7: "【国产/进口】国产",
          c8: "【注册证号】苏械注准20172201070",
          c9: "【生产企业】江苏鱼跃医疗设备股份有限公司",
        },
        {
          id: 24,
          goodsPic: require("../assets/drug-24.png"),
          goodsName: "红外线电子体温计 儿童额温枪 MC-872",
          p1: "179.00",
          c1: "【产品名称】红外线电子体温计 儿童额温枪 MC-872",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】电子体温计",
          c4: "【商品毛重】240.00g",
          c5: "【适用人群】婴幼儿",
          c6: "【测量部位】额温",
          c7: "【记忆功能】支持",
          c8: "【国产/进口】国产",
          c9: "【注册证号】苏械注准20152200153",
          c10: "【生产企业】昆山热映光电有限公司",
        },
        {
          id: 25,
          goodsPic: require("../assets/drug-25.png"),
          goodsName: "多普勒胎心仪 孕妇听胎心监测仪",
          p1: "128.00",
          c1: "【产品名称】多普勒胎心仪 孕妇听胎心监测仪",
          c2: "【商品名/商标】邦力健",
          c3: "【类别】多普勒胎心仪",
          c4: "【商品毛重】390.00g",
          c5: "【显示类型】数字",
          c6: "【国产/进口】国产",
          c7: "【注册证号】 粤械注准20182230732",
          c8: "【生产企业】深圳申瑞医疗有限公司",
        },
        {
          id: 26,
          goodsPic: require("../assets/drug-26.png"),
          goodsName: "腰椎固定带",
          p1: "68.00",
          c1: "【产品名称】可孚 护腰带腰椎固定带",
          c2: "【商品名/商标】可孚",
          c3: "【类别】康复护具",
          c4: "【商品毛重】100.00g",
          c5: "【适用部位】腰部",
          c6: "【适用人群】通用",
          c7: "【国产/进口】国产",
          c8: "【注册证号】湘长械备20160013",
          c9: "【生产企业】湖南可孚医疗科技发展有限公司",
        },
        {
          id: 27,
          goodsPic: require("../assets/drug-27.png"),
          goodsName: "欧姆龙电子血压计",
          p1: "398.00",
          c1: "【产品名称】医用测血压仪器降压仪血压表",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】上臂式",
          c4: "【商品毛重】1.0kg",
          c5: "【国产/进口】国产",
          c6: "【注册证号】辽械注准20162200146",
          c7: "【生产企业】欧姆龙(大连)有限公司",
        },
        {
          id: 28,
          goodsPic: require("../assets/drug-28.png"),
          goodsName: "欧姆龙雾化器家用",
          p1: "398.00",
          c1: "【产品名称】欧姆龙雾化器家用",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】压缩式",
          c4: "【适用人群】儿童",
          c5: "【商品毛重】500.00g",
          c6: "【国产/进口】国产",
          c7: "【注册证号】辽械注准20172230070",
          c8: "【生产企业】欧姆龙(大连)有限公司",
        },
        {
          id: 29,
          goodsPic: require("../assets/drug-29.png"),
          goodsName: "鼎泰和负压拔罐器",
          p1: "188.00",
          c1: "【产品名称】鼎泰和负压拔罐器",
          c2: "【商品名/商标】鼎泰和",
          c3: "【适用部位】全身",
          c5: "【商品毛重】500.00g",
          c6: "【国产/进口】国产",
          c7: "【注册证号】鲁青械备20150122",
          c8: "【生产企业】青岛鼎泰和医疗器械有限公司",
        },
        {
          id: 30,
          goodsPic: require("../assets/drug-30.png"),
          goodsName: "欧姆龙OMRON便携上臂式电子血压计",
          p1: "259.00",
          c1: "【产品名称】欧姆龙OMRON便携上臂式电子血压计",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】上臂式",
          c4: "【商品毛重】500.00g",
          c5: "【国产/进口】国产",
          c6: "【注册证号】辽食药监械(准)字2014第2200223号",
          c7: "【生产企业】欧姆龙(大连)有限公司",
        },
        {
          id: 31,
          goodsPic: require("../assets/drug-31.png"),
          goodsName: "欧姆龙压缩式医用雾化器NE-C801S",
          p1: "388.00",
          c1: "【产品名称】欧姆龙压缩式医用雾化器NE-C801S",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】压缩式",
          c4: "【适用人群】儿童",
          c5: "【商品毛重】1.0kg",
          c6: "【国产/进口】国产",
          c7: "【注册证号】辽械注准20142210025",
          c8: "【生产企业】欧姆龙（大连）有限公司",
        },
        {
          id: 32,
          goodsPic: require("../assets/drug-32.png"),
          goodsName: "医用家用上臂式电子血压计高血压测量仪血压仪",
          p1: "259.00",
          c1: "【产品名称】医用家用上臂式电子血压计高血压测量仪血压仪",
          c2: "【商品名/商标】欧姆龙（OMRON）",
          c3: "【类别】上臂式",
          c4: "【商品毛重】0.55kg",
          c5: "【国产/进口】国产",
          c6: "【注册证号】辽食药监械(准)字2014第2200224号",
          c7: "【生产企业】欧姆龙（大连）有限公司",
        },
        {
          id: 33,
          goodsPic: require("../assets/drug-33.png"),
          goodsName: "压力绷带（束腹带）",
          p1: "89.00",
          c1: "【产品名称】压力绷带（束腹带）",
          c2: "【商品名/商标】压力绷带",
          c3: "【类别】医用绷带",
          c4: "【商品毛重】200.00g",
          c5: "【国产/进口】国产",
          c6: "【注册证号】冀衡械备20190053号",
          c7: "【生产企业】衡水冠宸运动护具科技有限公司",
        },
        {
          id: 34,
          goodsPic: require("../assets/drug-34.png"),
          goodsName: "压力绷带（全扣式加强型束腹带）",
          p1: "129.00",
          c1: "【产品名称】压力绷带（全扣式加强型束腹带）",
          c2: "【商品名/商标】压力绷带",
          c3: "【类别】医用绷带",
          c4: "【商品毛重】230.00g",
          c5: "【国产/进口】国产",
          c6: "【注册证号】沪青械备20160004号",
          c7: "【生产企业】上海瑞瀚保健用品制造有限公司",
        },
        {
          id: 35,
          goodsPic: require("../assets/drug-35.png"),
          goodsName: "可孚 血压测量仪",
          p1: "108.00",
          c1: "【产品名称】可孚 血压测量仪",
          c2: "【商品名/商标】可孚",
          c3: "【类别】上臂式",
          c4: "【商品毛重】330.00g",
          c5: "【国产/进口】国产",
          c6: "【注册证号】湘食药监械(准)字2012第2200097号",
          c7: "【生产企业】湖南可孚医疗科技发展有限公司",
        },
        {
          id: 36,
          goodsPic: require("../assets/drug-36.png"),
          goodsName: "医用固定带腰部",
          p1: "52.00",
          c1: "【产品名称】医用固定带腰部",
          c2: "【商品名/商标】思维",
          c3: "【类别】牵引器",
          c4: "【商品毛重】800.00g",
          c5: "【国产/进口】国产",
          c6: "【注册证号】浙杭械备20150377号",
          c7: "【生产企业】杭州思维医疗器械有限公司",
        },
      ],
      pharmacyInfo: [
        {
          id: 0,
          q1: "慈善大药房有限公司",
          q2: "5.0",
          q3: "5.0",
          q4: "5.0",
          q5: "5.0",
          q6: "4.8",
          q7: "2.2小时",
          q8: "8:00-20:00",
          q9: "江苏省苏州市姑苏区",
          q10: "杨经理",
          q11: "13857327081"
        },
        {
          id: 1,
          q1: "苏州华业药店有限公司",
          q2: "4.9",
          q3: "4.9",
          q4: "4.9",
          q5: "4.9",
          q6: "4.9",
          q7: "3小时",
          q8: "9:00-21:00",
          q9: "江苏省苏州市吴中区",
          q10: "沈经理",
          q11: "13819377270"
        },
      ],
    };
  },
  created() {
    // 获取路由参数中的药品ID
    const drugId = parseInt(this.$route.params.drugId);
    // 查找对应的药品信息
    const drug = this.drugList.find(item => item.id === drugId);
    if (drug) {
      this.drugTitle = drug.goodsName;
      this.drugPic = drug.goodsPic;
      this.p1 = drug.p1;
      this.c1 = drug.c1;
      this.c2 = drug.c2;
      this.c3 = drug.c3;
      this.c4 = drug.c4;
      this.c5 = drug.c5;
      this.c6 = drug.c6;
      this.c7 = drug.c7;
      this.c8 = drug.c8;
      this.c9 = drug.c9;
      this.c10 = drug.c10;
      this.q1 = drug.q1;
      this.q2 = drug.q2;
      this.q3 = drug.q3;
      this.q4 = drug.q4;
      this.q5 = drug.q5;
      this.q6 = drug.q6;
      this.q7 = drug.q7;
      this.q8 = drug.q8;
      this.q9 = drug.q9;
      this.q10 = drug.q10;
      this.q11 = drug.q11;
    }
  },
  methods: {
    login() {
      this.isShow = true;
      this.isMask = true;
    },
    fnRegister(data) {
      if (data == false) {
        this.isShow = false;
        this.Register = true;
      }
    },
    closeLogin(data) {
      if (data == false) {
        this.isShow = false;
        this.isMask = false;
      }
    },
    goLogin(data) {
      if (data == false) {
        this.Register = false;
        this.isShow = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 1220px;
  margin: 20px auto;

  .back-button {
    margin-bottom: 20px;
    
    .ant-btn-link {
      color: #1890ff;
      font-size: 16px;
      
      &:hover {
        color: #40a9ff;
      }
      
      .anticon {
        margin-right: 4px;
      }
    }
  }

  .drugTop {
    width: 1220px;
    height: 550px;
    box-shadow: 0 7px 17px 4px rgba(220, 220, 220, 0.5);
    border-radius: 8px;

    .drugLeft {
      float: left;

      img {
        width: 448px;
        height: auto;
        margin: 50px 70px;
      }
    }

    .drugRight {
      font-size: 20px;
      color: #333333;
      float: left;
      margin-top: 100px;

      .drugMes {
        margin-top: 30px;
        height: 100px;

        .drugMes_l {
          font-size: 16px;
          float: left;

          .drugMes_t {
            margin-top: 20px;
          }
        }

        .drugMes_r {
          font-size: 16px;
          float: left;
          margin-left: 100px;

          .drugMes_t {
            margin-top: 20px;
          }
        }
      }

      .price {
      }
    }
  }

  .drugBottom {
    margin-top: 50px;
    box-shadow: 0 7px 17px 4px rgba(220, 220, 220, 0.5);
    border-radius: 8px;
    overflow: hidden;

    .drugBox {
      font-size: 20px;
      font-weight: 900;
      text-align: left;
      margin-top: 30px;
      margin-left: 70px;
    }

    .drugInfo {
      text-align: left;
      margin-top: 30px;
      margin-left: 70px;
      font-size: 20px;

      p {
        width: 1100px;
      }
    }
  }
}
</style>
